import moment from 'moment'

import { TConvertHexToRGBA, TStylize, TDateDiff, TDateFormat } from './types'

// Configs
moment.defineLocale('pt-br', {
  monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
})

/**
 * @function convertHexToRGBA
 * @param hex
 * @param opacity
 */
const convertHexToRGBA = ({ hex, opacity }: TConvertHexToRGBA): string => {
  hex = hex.replace('#', '')

  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  return `rgba(${r},${g},${b},${opacity / 10})`
}

/**
 * @function stylize
 */
const stylize = ({ element, style }: TStylize): Record<any, any> =>
  Object.assign(element?.style || {}, style)

/**
 * @function isValidURL
 * @param url
 */
const isValidURL = (url?: string): boolean => {
  if (url) {
    return (
      /* eslint-disable */
      url.match(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
      ) !== null
    )
  } else {
    return false
  }
}

/**
 * @function matchRoutes
 * @param routes
 */
const matchRoute = (routes: object): boolean =>
  Object.entries(routes).some(([, route]) => route === window.location.pathname)

/**
 * @function dateDiff
 * @param dateStart
 * @param dateEnd
 */
const dateDiff = ({ dateStart, dateEnd }: TDateDiff) => {
  const pattern = 'DD-MM-YYYY HH:mm:ss'

  let a = moment(dateFormat({ date: dateStart }), pattern)
  let b = moment(dateEnd, pattern)

  return b.diff(a, 'days')
}

/**
 * @method dateFormat
 * @param date
 * @param pattern
 */
const dateFormat = ({ date, pattern = 'DD-MM-YYYY hh:mm:ss' }: TDateFormat) =>
  moment(date, 'DD-MM-YYYY hh:mm:ss').format(pattern)

/**
 * @function setFavicon
 * @param image
 */
const setFavicon = (image: string): void => {
  let headTitle = document.querySelector('head')
  let setFavicon = document.createElement('link')

  setFavicon?.setAttribute('rel', 'shortcut icon')
  setFavicon?.setAttribute('href', image)
  headTitle?.appendChild(setFavicon)
}

const wait = (time: number) => new Promise(resolve => setTimeout(resolve, time))

export {
  wait,
  convertHexToRGBA,
  stylize,
  isValidURL,
  matchRoute,
  dateDiff,
  dateFormat,
  setFavicon,
}
